<template>
  <div class="home">
    <!-- :class="{ warning: parseInt(usingRate) > 60, danger: parseInt(usingRate) > 80 }" -->
    <div class="container">
      <div class="wave"></div>
      <div class="wave-mask" :style="`top: ${50 - parseInt(usingRate)}px`"></div>
      <div class="wave-mask2" :style="`top: ${50 - parseInt(usingRate)}px`"></div>
      <div class="txt-ponts">
        <p>
          <span>{{usingRate}}</span>
          <span>%</span>
        </p>
        <p>任务进度</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    usingRate: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  border: 2px solid rgba(178, 211, 255, 0.2);
  background: #ffffff;
  overflow: hidden;
  padding: 5px;
  position: relative;
  .wave {
    position: relative;
    width: 130px;
    height: 130px;
    background-image: linear-gradient(-180deg, #b2d3ff 13%, #509aff 91%);
    border-radius: 50%;
  }
  .wave-mask {
    position: absolute;
    width: 220px;
    height: 220px;
    top: 0;
    left: 50%;
    border-radius: 42%;
    background-color: rgba(255, 255, 255, 0.9);
    transform: translate(-50%, -70%) rotate(0);
    animation: toRotate 20s linear -5s infinite;
    z-index: 20;
  }
  .wave-mask2 {
    position: absolute;
    width: 220px;
    height: 220px;
    top: 20px;
    left: 50%;
    border-radius: 42%;
    background-color: rgba(255, 255, 255, 0.8);
    transform: translate(-50%, -70%) rotate(0);
    animation: toRotate 10s linear -5s infinite;
    z-index: 20;
  }
  &.warning {
    border: 3px solid #e6a23c;
    .wave {
      background-image: linear-gradient(-180deg, #f0c78a 13%, #e6a23c 91%);
    }
    &.danger {
      border: 3px solid #f56c6c;
      .wave {
        background-image: linear-gradient(-180deg, #f78989 13%, #f56c6c 91%);
      }
    }
  }
}
.using-slider {
  width: 400px;
  margin: 0 auto;
}

@keyframes toRotate {
  50% {
    transform: translate(-50%, -70%) rotate(180deg);
  }
  100% {
    transform: translate(-50%, -70%) rotate(360deg);
  }
}
.txt-ponts {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 22;
  p:first-child span:first-child {
    font-size: 50px;
    font-weight: bold;
  }
  p:first-child span:last-child {
    font-size: 20px;
  }
  p:last-child {
    font-size: 14px;
    color: rgba(25, 24, 67, 0.6);
    text-align: center;
  }
}
</style>
